import { Component, OnInit } from '@angular/core';

import { IMenuItem } from './menu-item';
import { MenuService } from './menu.service';
import { SessionService } from '../../session.service'
@Component({
  moduleId: module.id,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [MenuService],
  host: {
    'class': 'app-menu'
  }
})
export class MenuComponent implements OnInit {
  menuItems: IMenuItem[];
  permission:string;
  constructor( private _sessionService:SessionService,private menuService: MenuService ) { 

    this.permission = this._sessionService.getSessionPermission();
  }

  getMenuItems(): void {
    console.log('permission',this.permission);
    if(this.permission=="1"){
      this.menuService.getMenuItems().then(menuItems => this.menuItems = menuItems);
    }else if(this.permission=="2"){
      this.menuService.getMenuItems1().then(menuItems => this.menuItems = menuItems);
    }else if(this.permission=="3"){
      this.menuService.getMenuItems2().then(menuItems => this.menuItems = menuItems);
    }else if(this.permission=="4"){
      this.menuService.getMenuItems3().then(menuItems => this.menuItems = menuItems);
    }else if(this.permission=="5"){
      this.menuService.getMenuItems4().then(menuItems => this.menuItems = menuItems);
    }else if(this.permission=="6"){
      this.menuService.getMenuItems5().then(menuItems => this.menuItems = menuItems);
    }
    else if(this.permission=="7"){
      this.menuService.getMenuItems6().then(menuItems => this.menuItems = menuItems);
    }
    else if(this.permission=="12"){
      this.menuService.getMenuItems6().then(menuItems => this.menuItems = menuItems);
    }
    else{
      //this.menuService.getMenuItems().then(menuItems => this.menuItems = menuItems);
    }
   
  }
  getLiClasses(item: any, isActive: any) {
    return {
      'has-sub': item.sub,
      'active': item.active || isActive,
      'menu-item-group': item.groupTitle,
      'disabled': item.disabled
    };
  }
  getStyles(item: any) {
    return {
      'background': item.bg,
      'color': item.color
    };
  }

  ngOnInit(): void {
    this.getMenuItems();
  }

  toggle(event: Event, item: any, el: any) {
    event.preventDefault();

    let items: any[] = el.menuItems;

    if (item.active) {
      item.active = false;
    } else {
      for (let i = 0; i < items.length; i++) {
        items[i].active = false;
      }
      item.active = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/menu/menu.component.ts